import { render, staticRenderFns } from "./IndexTraspaso.vue?vue&type=template&id=c201bc78&scoped=true"
import script from "./IndexTraspaso.vue?vue&type=script&lang=js"
export * from "./IndexTraspaso.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./IndexTraspaso.vue?vue&type=style&index=1&id=c201bc78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c201bc78",
  null
  
)

export default component.exports